export default "__VITE_ASSET__J735HhYn__"